import React from "react";
import { Navigation } from "types/navigation";
import { Home, AccountBalance } from "@mui/icons-material";
import { BankHome } from "views/Bank";
import { LTVCalculator } from "views/SuperAdmin/Tools";

export const bankPages: Navigation = [
  { kind: "header", title: "Bank" },
  {
    segment: "bankAgent",
    title: "Home",
    icon: <Home />,
    component: <BankHome />,
  },
  {
    segment: "bankAgent/ltv-calculator",
    title: "LTV Calculator",
    icon: <AccountBalance />,
    component: <LTVCalculator />,
  },
];